<template>
  <ScrollShadow
    class="height-100"
    data-qa="comments-chat-content">
    <div class="chat">
      <div
        class="chat-comments-cards"
        data-qa="chat-comments-cards">
        <CommentItem
          v-for="(question, questionIndex) in items"
          :key="`comment-${question.questionId}-${questionIndex}`"
          :item="question"
          @answer="value => $emit('answer', {index: questionIndex, value})"/>
      </div>
    </div>
  </ScrollShadow>
</template>
<script>
import ScrollShadow from 'components/common/ScrollShadow.vue'
import CommentItem from 'components/common/blocks/comments/CommentItem.vue'
/**
 * Чат вопросов к организатору
 */
export default {
  name: 'commentsChat',
  methods: {
    scrollToLastItem() {
      setTimeout(() => {
        const itemActive = document.getElementsByClassName('chat-comment')
        if (itemActive?.length) {
          itemActive[itemActive.length - 1].scrollIntoView({block: 'center', behavior: 'smooth'})
        }
      }, 250)
    }
  },
  created() {
    this.scrollToLastItem()
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.scrollToLastItem()
      }
    },
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.scrollToLastItem()
        }
      }
    }
  },
  props: {
    items: {
      type: Array,
      require: true
    },
    show: {
      type: Boolean
    }
  },
  components: {
    CommentItem,
    ScrollShadow
  }
}
</script>
<style scoped>
.chat-comments-cards {
  background: var(--v-main__light_green-base);
  padding: 0px 30px 5px 20px;
  border-radius: 0px 0px 8px 8px;
}
</style>
